import React from 'react'
import { useTranslation } from 'react-i18next'
import Box from '@node-space/storybook-components/dist/Box'
import CopyButton from '@node-space/storybook-components/dist/CopyButton'
import Text from '@node-space/storybook-components/dist/Text'

interface DetailRowProps {
  label: string
  detail: string
  isCopyEnabled?: boolean
}

const DetailRow = ({ label, detail, isCopyEnabled = false }: DetailRowProps) => {
  const { t } = useTranslation()

  return (
    <Box className="lg:flex-row" flex direction="col" paddingT={4} paddingB={4}>
      <Text tag="span" size="sm" color="disabled" className="md:w-2/5">
        {label}
      </Text>
      <Text
        tag="span"
        size="sm"
        weight="medium"
        color="dark-grey"
        className="md:w-3/5 flex justify-start lg:justify-end"
      >
        <Box flex flexItemsCenter gap={8}>
          <Text tag="span" size="sm">
            {detail}
          </Text>
          {isCopyEnabled && (
            <CopyButton
              copyText={detail}
              confirmationMessage={t('copiedToClipboard')}
              confirmationMessageAlignment="left"
              confirmationMessageTheme="dark"
            />
          )}
        </Box>
      </Text>
    </Box>
  )
}

export default DetailRow
